import { AsapBaseService } from 'asap-crud';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthService extends AsapBaseService {

    public params:any = null;

    constructor(public http: HttpClient) {
        super(http);
        this.basePath = 'api';
        this.entityName = 'v2'
    }

    public getUserLogged() {
        return this.getResources({router: 'client/user/authenticated'});
    }

    public verify() {
        return this.getResources({router: 'client/verifica'});
    }

    public getLinkedAccounts(clientId: number | string = 20) {
        this.basePath = 'api/v2';
        this.entityName = 'admin/asap-client/vinculo';
        return this.getResource(clientId, { query: `client_id=${clientId}` });
    }

    public switchAccount(targetAccountId: number | string, currentClientId: number | string = 20) {
        this.basePath = 'api';
        this.entityName = 'switch';
        return this.getResource(targetAccountId, { query: `client_id=${currentClientId}` });
    }

    public setSessionToken(data): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const token = 'Bearer' + ' ' + data.token;
            sessionStorage.setItem('token', token);
            setTimeout(() => {
                this.getUserLogged().subscribe((response: any) => {
                    this.verify().subscribe(verifica => {
                        if (response.success === false) {
                            resolve(false);
                        } else {
                            sessionStorage.setItem('loggedUser', JSON.stringify(response));
                            sessionStorage.setItem('language', response.data.language);
                            sessionStorage.setItem('client', response.data.client_id);
                            if (response.data && response.data.certificate) {
                                sessionStorage.setItem('asap_certificate_base', String(response.data.certificate).trim());
                                localStorage.setItem('asap_certificate_base', String(response.data.certificate).trim());
                            }
                            resolve(true);
                        }
                    });
                }, err => reject(err));
            }, 100);
        });
    }

}